<template>
  <div class="balance_enjoy_modal_box">
    <b-modal
      ref="modal"
      :id="modalId"
      hide-footer
      centered
      title="餘額即享券"
      modal-class="discount-modal"
    >
      <form>
        <div class="input-area">
          <div class="bouns single-input">
            <div class="d-flex input-head">
              <p class="input-name">折抵金額</p>
              <p>
                即享券餘額
                <span class="red-text">{{ balance }}</span>
                元
              </p>
            </div>
            <div class="">
              <input
                v-model="enjoybalance"
                type="number"
                placeholder="請輸入金額"
                v-validate="bonusInputRules"
                name="enjoybalance"
                class="discount-text-input"
                min=0
                :class="{ 'wrong-border': errors.has('enjoybalance') }"
              />
              <span class="red-text">{{ errors.first('enjoybalance') }}</span>
            </div>
          </div>
        </div>

        <div slot="modal-footer" class="modal_footer">
          <div class="text-center">
            <b-btn
              class="hoverFill"
              @click="handleHide"
              v-b-modal.denomination_modal
            >
              取消
            </b-btn>
            <a class="btn hoverFill btn-secondary" @click="submit">
              確認
            </a>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';
export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    bonusData: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      enjoybalance: ''
    };
  },
  computed: {
    ...mapGetters('cart', ['products']),

    bonusInputRules() {
      return `max_value:${this.balance}`;
    },

    modalId() {
      return 'balance_enjoy_modal' + this.index;
    },

    balanceData() {
      return this.products[this.index].enJoyRes;
    },

    //餘額型即享券資料
    balanceEnjoy() {
      return this.products[this.index].balanceEnjoy;
    },

    //暫存資料
    temp() {
      return this.products[this.index].TempSave;
    },

    balance() {
       let data = _.get(this.balanceData, 'balance', 0);
       let newData= Math.ceil(data)
       return newData
    },
    bonusDis() {
      return this.temp.bonusDis;
    },
    parseBonusDis() {
      return parseInt(this.bonusDis) || 0;
    },
    couponDis() {
      return this.temp.couponDis;
    },
    parseCouponDis() {
      return parseInt(this.couponDis) || 0;
    },

    enjoyDis() {
      return this.enjoybalance;
    },
    parseEnjoyDis() {
      return parseInt(this.enjoyDis) || 0;
    }
  },
  methods: {
    ...mapMutations('cart', ['setCartProductsDiscount']),

    handleHide() {
      this.$refs.modal.hide();
      this.$bvModal.show('discoupon_modal' + this.index);
    },

    calculate() {
      //總抵扣金額
      let minusAmount =
        this.parseBonusDis + this.parseEnjoyDis + this.parseCouponDis;

      //總金額
      let totalPrice = this.product.price * this.product.quantity;

      //實付金額
      let payPrice = this.product.price * this.product.quantity - minusAmount;

      if (payPrice < 0) {
        if (totalPrice - this.parseBonusDis < 0) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }

        if (totalPrice - (this.parseBonusDis + this.parseEnjoyDis) < 0) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }

        if (
          totalPrice -
            (this.parseBonusDis + this.parseEnjoyDis + this.parseCouponDis) <
          0
        ) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }
        return;
      }

      //資料存進vuex
      this.setCartProductsDiscount({
        index: this.index,
        enjoyDis: this.enjoyDis,
        minusAmount: minusAmount,
        payPrice: payPrice,
        SkuNo30: this.balanceEnjoy.Skuno,
        ReturnSkuNo30: this.balanceEnjoy.ReturnSkuno,
        DiscType30: this.balanceEnjoy.DiscType,
        Grno30: this.balanceEnjoy.Grno,
        rebateName30: this.balanceEnjoy.RebateName,
        accountType: 3,
        bonusDis: this.temp.bonusDis,
        RbonusPoints: this.temp.RbonusPoints,
        bonusDefaultNum: this.temp.bonusDefaultNum,
        couponDis: this.temp.couponDis,
        ticketNo: this.temp.ticketNo,
        EventMastId: this.temp.EventMastId,
        EventDetlId: this.temp.EventDetlId,
        DESCRITPION: this.temp.DESCRITPION,
        DiscTypePoint: this.temp.DiscTypePoint,
        DscSku: this.temp.DscSku,
        SkuNoPoint: this.temp.SkuNoPoint,
        copu_type: this.temp.copu_type,
        SkuNo10: this.temp.SkuNo10,
        ReturnSkuNo10: this.temp.ReturnSkuNo10,
        DiscType10: this.temp.DiscType10,
        Grno10: this.temp.Grno10,
        rebateName10: this.temp.rebateName10
      });
    },

    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.calculate();
          this.$refs.modal.hide();
        } else {
          alert('輸入資料有誤');
        }
      });
    }
  },
  created() {
    const dict = {
      custom: {
        enjoybalance: {
          max_value: function(n, e) {
            return '您的' + n + ' 現在只有 ' + e[0] + '元。'; //custom 中設定 錯誤訊息返回的字串  n是input name e是定義的規則
          }
        }
      },
      attributes: {
        enjoybalance: '即享券餘額' //attribute 中設定 input name的中文
      }
    };
    this.$validator.localize('zh_TW', dict);
  }
};
</script>
